import {PanelContent} from '@tritt/multipanel'
import DocumentPreview from '@/document/DocumentPreview.vue'
import {registerRoute} from '@/router'

export const DOCUMENT_VIEW: PanelContent = {
    componentName: 'DocumentPreview',
    path: '/document/{documentUuid}',
    component: DocumentPreview,
    meta: { requiresOrg: true }
}

registerRoute(DOCUMENT_VIEW)